module.exports = "/_next/static/resources/life1-72884b9be7357c7888e12f19f8ffcf2f.jpg";